import {
    isGroupTableQuery,
    lazyGetRetentionPolicyTagListForGroupTableQuery,
    lazyGetRetentionPolicyTagsForGroup,
} from 'owa-group-utils';
import type { TableView } from 'owa-mail-list-store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import getSharedFolderPolicyTagList from 'owa-shared-folder/lib/selectors/getSharedFolderPolicyTagList';
import type { MailboxType } from 'owa-graph-schema';

export function getRetentionPolicyTagList(
    tableView: TableView,
    mailboxType: MailboxType,
    principalSMTPAddress: string,
    groupId?: string
) {
    if ((tableView && isGroupTableQuery(tableView.tableQuery)) || groupId) {
        if (groupId) {
            const getRetentionPolicyTagsForGroup = lazyGetRetentionPolicyTagsForGroup.tryImportForRender();
            return getRetentionPolicyTagsForGroup ? getRetentionPolicyTagsForGroup(groupId) : [];
        } else {
            const getRetentionPolicyTagListForGroupTableQuery = lazyGetRetentionPolicyTagListForGroupTableQuery.tryImportForRender();
            return getRetentionPolicyTagListForGroupTableQuery
                ? getRetentionPolicyTagListForGroupTableQuery(tableView.tableQuery)
                : [];
        }
    }

    if (mailboxType === 'SharedMailbox') {
        return getSharedFolderPolicyTagList(principalSMTPAddress);
    }

    return getUserConfiguration().RetentionPolicyTags;
}

export function getRetentionPolicyTagListForItem(
    mailboxType: MailboxType,
    principalSMTPAddress: string,
    folderId: string
) {
    if (mailboxType === 'GroupMailbox') {
        const getRetentionPolicyTagsForGroup = lazyGetRetentionPolicyTagsForGroup.tryImportForRender();
        return getRetentionPolicyTagsForGroup ? getRetentionPolicyTagsForGroup(folderId) : [];
    }

    if (mailboxType === 'SharedMailbox') {
        return getSharedFolderPolicyTagList(principalSMTPAddress);
    }

    return getUserConfiguration().RetentionPolicyTags;
}
